"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Maintains references to all widgets and the ability to rerender them.  This is useful
 * to update the styling of the widgets if TabStyles is modified.  Some UI libraries like
 * Material UI use React's context to pass along the Style, however not all our clients
 * use a complete React tree and there may be complications with PureRenderMixins in that
 * updating the context may not update the component.
 */
var WidgetManager = /** @class */ (function () {
    function WidgetManager() {
    }
    WidgetManager.registerWidget = function (widget) {
        WidgetManager.widgets.push(widget);
    };
    WidgetManager.unregisterWidget = function (widget) {
        WidgetManager.widgets = WidgetManager.widgets.filter(function (w) { return w !== widget; });
    };
    WidgetManager.rerenderWidgets = function () {
        for (var i = 0; i < WidgetManager.widgets.length; i++) {
            WidgetManager.widgets[i].forceUpdate();
        }
    };
    WidgetManager.widgets = [];
    return WidgetManager;
}());
exports.WidgetManager = WidgetManager;
//# sourceMappingURL=WidgetManager.js.map